<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <order-state-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import OrderStateCrud from "./OrderStateCrud";
    export default {
        name: "OrderState",
        components: {OrderStateCrud}
    }
</script>

<style scoped>

</style>

